import React from 'react';
import { getEntityTypeUrl } from '../../utils';
import { Link } from 'react-router-dom';

interface PageProps {
  entityNumber: string;
  entityType: string;
  entityId?: string | null;
}
export const EntitlementPageLink = ({ entityNumber, entityType, entityId }: PageProps) => {
  return <Link to={getEntityTypeUrl(entityType, entityNumber, entityId)}>{entityNumber}</Link>;
};
